'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rx = require('rx');

var _maxChunkSize = require('./maxChunkSize');

var _maxChunkSize2 = _interopRequireDefault(_maxChunkSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (eventStream) {
  var chunks = [];
  var currChunk = [];
  var chunkSize = 0;

  eventStream.forEach(function (event) {
    if (event.length + chunkSize > (0, _maxChunkSize2.default)()) {
      chunks.push(currChunk);
      currChunk = [event];
      chunkSize = event.length;
    } else {
      currChunk.push(event);
      chunkSize = chunkSize + event.length;
    }
  });

  return _rx.Observable.from([].concat(chunks, [currChunk]));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-impression-tracking/build/splitByMaxUrlSize.js
 ** module id = 46
 ** module chunks = 0
 **/